import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import {
  SALES_CUSTOMER_CARE_SCOPE,
  type SalesCustomerCareScope,
} from '@/scopes/care-commons/utils/logger/salesCustomerCare/config'
import { useSalesCustomerCareLogger } from '@/scopes/care-commons/utils/logger/salesCustomerCare/useSalesCustomerCareLogger'

export function useOrderlineLightDetails() {
  const { logHttpError } = useSalesCustomerCareLogger()
  const $httpFetch = useHttpFetch()

  const fetchOrderlineLightDetails = (
    // UUID or internal numerical ID
    orderlineId: string,
    scope: SalesCustomerCareScope = SALES_CUSTOMER_CARE_SCOPE.myOrders,
  ) =>
    $httpFetch('/my-orders/orderlines/:orderlineId/light', {
      pathParams: {
        orderlineId,
      },
      onResponseError: ({ response }) => {
        if (response) {
          logHttpError({
            // eslint-disable-next-line no-underscore-dangle
            error: response._data as Error,
            errorStatusCode: response.status,
            errorTitle: `${scope} [Orderline #${orderlineId}] Error when fetching orderline light details`,
          })
        }
      },
    })

  return {
    fetchOrderlineLightDetails,
  }
}
